<template>
  <div class="export-wrap">
    <el-dialog
      :title="editRow.name?'编辑机器人':'添加机器人'"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :before-close="hideDialog"
      custom-class="mainDialog"
    >
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        class="demo-ruleForm"
      >
        <el-form-item label="机器人名称" prop="name" :error="errorName">
          <el-input v-model="ruleForm.name" placeholder="请填写机器人名称" maxlength="255" @blur="onBlur" @focus="onFocus"></el-input>
        </el-form-item>
        <el-form-item label="机器人描述" prop="description">
          <el-input v-model="ruleForm.description" placeholder="请填写机器人描述" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="机器人数据推送接口" prop="url">
          <el-input v-model="ruleForm.url" placeholder="请填写机器人数据推送接口" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="话术模板列表接口" prop="templateUrl">
          <el-input v-model="ruleForm.templateUrl" placeholder="请填写话术模板列表接口" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="创建外呼计划接口" prop="scheduleTaskUrl">
          <el-input v-model="ruleForm.scheduleTaskUrl" placeholder="请填写创建外呼计划接口" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="机器人外呼反馈接口" prop="scheduleTaskUrl">
          <el-input v-model="ruleForm.fetchCallrecordUrl" placeholder="请填写机器人外呼反馈接口" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="机器人跳转链接" prop="externalUrl">
          <el-input v-model="ruleForm.externalUrl" placeholder="请填写机器人跳转链接" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="外呼计划列表接口" prop="scheduleTaskListUrl">
          <el-input v-model="ruleForm.scheduleTaskListUrl" placeholder="请填写外呼计划列表接口" maxlength="255"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="hideDialog">取 消</el-button>
        <el-button type="primary" @click="editRow.name?editSystem():addToSystem()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="删除"
      :visible.sync="delSystemVisible"
      :close-on-click-modal="false"
      :before-close="hideDelDialog"
      custom-class="redDialog"
    >
    <strong style='color:#555;font-size:16px;'>确定删除"
        <span style="color: #ec6459">{{editRow.name}}</span>"?
    </strong>
      <span slot="footer" class="dialog-footer">
        <el-button @click="hideDelDialog">取 消</el-button>
        <el-button type="primary" @click="ensureDel">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props:['plugin','delSystemVisible','dialogVisible','editRow'],
  data() {
    return {
      title: "添加机器人",
      ruleForm: {
          name: '',
          description:'',
          url:'',
          templateUrl:'',
          scheduleTaskUrl:'',
          fetchCallrecordUrl:'',
          externalUrl:'',
          scheduleTaskListUrl:''
      },
      rules:{
        name:[
          { required: true, message: '请填写必填项', trigger: 'blur' },
        ]
      },
      errorName:''
    };
  },
  watch:{},
  created(){},
  methods: {
    initForm(init=true,_item){
      if(!init){
        this.ruleForm = Object.assign(this.ruleForm,_item);
        return
      }
      this.ruleForm = {
          name: '',
          description:'',
          url:'',
          templateUrl:'',
          scheduleTaskUrl:'',
          fetchCallrecordUrl:'',
          externalUrl:'',
          scheduleTaskListUrl:''
      }
    },
    onBlur(){
      if(!this.ruleForm.name){
        return this.errorName = '请填写必填项';
      }

      let checkList = JSON.parse(JSON.stringify(this.plugin));

      if(this.editRow.name){
        // 编辑弹窗时,自己姓名不进行判断
        const index = checkList.findIndex((item)=>{return item.name==this.editRow.name});
        checkList.splice(index,1);
      }
      // 查重，报错 机器人名称重复
      let checkName = checkList.some((item)=>{
          // console.log(item.name,'====')
          return item.name == this.ruleForm.name
      })
      this.errorName = checkName?'机器人名称重复':'';
      // console.log(checkName,'checkName')
    },
    onFocus(){
      this.errorName = '';
    },
    hideDialog() {
      this.errorName = '';
      this.$emit('hideDialog')
    },
    async addToSystem(){
      this.onBlur();
      let valid = !this.errorName;//校验表单是否报错
      if(valid){
        try{
          const result = await this.apiData('post', 'user/config/addPlugin',this.ruleForm);
          this.errorName = '';
          this.$emit('successAddSystem');
        }catch(error){
          if(error.code==1086){
            this.errorName='机器人名称重复'
          }
          this.$message.error(error.message)
        }
      }
    },
    async editSystem(){
      this.onBlur();
      let valid = !this.errorName;//校验表单是否报错
      let data = {
            pluginId:this.ruleForm._id,
            name: this.ruleForm.name,
            description:this.ruleForm.description,
            url:this.ruleForm.url,
            templateUrl:this.ruleForm.templateUrl,
            scheduleTaskUrl:this.ruleForm.scheduleTaskUrl,
            fetchCallrecordUrl:this.ruleForm.fetchCallrecordUrl,
            externalUrl:this.ruleForm.externalUrl,
            scheduleTaskListUrl:this.ruleForm.scheduleTaskListUrl
          }

      if(valid){
        try{
          const result = await this.apiData('put', 'user/config/updatePlugin',data);
          this.errorName = '';
          this.$emit('successAddSystem');
        }catch(error){
          if(error.code==1086){
            this.errorName='机器人名称重复'
          }
          this.$message.error(error.message)
        }
      }
    },
    // 删除弹窗
    hideDelDialog(){
      this.$emit('hideDelDialog')
    },
    async ensureDel(){
      try{
          const result = await this.apiData('post', 'user/config/deletePlugin',{pluginId:this.editRow._id});
          this.$emit('successDelSysten');
        }catch(error){
          this.$message.error(error.message);
          this.$emit('hideDelDialog')
        }
    },
  },
};
</script>

<style lang="scss" scoped>
  .export-wrap{
    .el-form-item{
      display: flex;
      width: 100%;
      justify-content: space-between;
      label{
        flex-shrink: 0;
      }
      .el-form-item__content{
        // width: 80%;
      }
    }
  }
</style>
<style lang="scss">
  .export-wrap{
    .el-form-item{
      label{
        flex-shrink: 0;
        text-align: right;
        width: 140px;
      }
      .el-form-item__content{
        width: 80%;
      }
    }
    .el-dialog__body{
      padding: 30px 40px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/user/addExportSystem.vue